export default __webpack_public_path__ + "static/media/Alok.5ad2d292.png";